<template>
    <div class="p-1">
        <div class="d-flex align-items-center flex-wrap gap-2 mb-3">
            <span class="text-sm text-secondary">
                Todo lo que los admins le han hecho a <code>{{ historial.tabla }}</code>
                <strong>#{{ historial.registro_id }}</strong>, del más reciente al más antiguo.
            </span>
            <a href="#" class="text-xs ms-auto" @click.prevent="$emit('filtrar', historial)">
                <i class="fas fa-filter me-1"></i>
                Ver acciones en el listado
            </a>
        </div>

        <div v-if="cargando" class="text-center py-4 text-muted small">
            <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
            Cargando historial...
        </div>

        <div v-else-if="!items.length" class="text-center text-muted py-4 small">
            <i class="fas fa-inbox d-block mb-2" style="font-size: 1.5rem; color: #cbd5e1"></i>
            No hay cambios registrados para este registro
        </div>

        <template v-else>
            <div v-for="cambio in items" :key="cambio.id" class="entrada">
                <div class="entrada-meta text-xs">
                    <span class="text-nowrap">{{ formatFecha(cambio.fecha) }}</span>
                    <span class="fw-semibold text-dark">{{ cambio.admin_email || `#${cambio.admin_user_id}` }}</span>
                    <span v-if="cambio.admin_role_nombre" class="text-muted">{{ cambio.admin_role_nombre }}</span>
                    <span v-if="cambio.impersonado_email" class="text-muted">
                        <i class="fas fa-user-secret text-warning me-1" title="Impersonando"></i>
                        como {{ cambio.impersonado_email }}
                    </span>
                    <span v-if="cambio.metodo" class="text-muted text-truncate url">
                        <span class="badge me-1" :class="claseMetodo(cambio.metodo)">{{ cambio.metodo }}</span>
                        <code class="text-xxs" :title="cambio.url">{{ cambio.url }}</code>
                    </span>
                </div>
                <cambio-auditoria :cambio="cambio" :con-historial="false" />
            </div>

            <div v-if="(paginador.last_page || 1) > 1" class="d-flex justify-content-center mt-3">
                <base-pagination
                    :current-page="paginador.current_page || 1"
                    :pageCount="paginador.last_page || 1"
                    @nextPage="irA((paginador.current_page || 1) + 1)"
                    @previousPage="irA((paginador.current_page || 1) - 1)"
                    @loadPage="irA"
                />
            </div>
        </template>
    </div>
</template>

<script>
import BasePagination from '@/components/pagination/BasePagination.vue';
import CambioAuditoria from './cambioAuditoria.vue';
import { formatFecha, claseMetodo } from '../formatoAuditoria.js';

export default {
    name: 'HistorialRegistro',
    components: { BasePagination, CambioAuditoria },
    props: {
        // { tabla, registro_id, paginador }
        historial: { type: Object, required: true },
        cargando: { type: Boolean, default: false }
    },
    emits: ['page', 'filtrar'],
    computed: {
        paginador() {
            return this.historial.paginador || {};
        },
        items() {
            return this.paginador.data || [];
        }
    },
    methods: {
        formatFecha,
        claseMetodo,
        irA(page) {
            const destino = Math.min(Math.max(parseInt(page) || 1, 1), this.paginador.last_page || 1);
            if (destino !== this.paginador.current_page) this.$emit('page', destino);
        }
    }
};
</script>

<style lang="scss" scoped>
.entrada + .entrada {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px dashed #e2e8f0;
}

.entrada-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.25rem 0.75rem;
    margin-bottom: 0.5rem;

    .url {
        max-width: 100%;
    }
}
</style>
